import { render, staticRenderFns } from "./containers-management-table.vue?vue&type=template&id=20d0e37a&scoped=true&"
import script from "./containers-management-table.vue?vue&type=script&lang=js&"
export * from "./containers-management-table.vue?vue&type=script&lang=js&"
import style0 from "./containers-management-table.vue?vue&type=style&index=0&id=20d0e37a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d0e37a",
  null
  
)

export default component.exports